import { Spacing, useResponsive, VStack } from "goi_common";
import { useRouter } from "next/router";

import B2BOpsHeader from "./B2BOpsHeader";

import Header from "./Header";

interface LayoutProps {
  children: React.ReactNode;
  showConditional?: boolean;
}

export default function Layout({ children, showConditional }: LayoutProps) {
  const { isBiggerThanLg } = useResponsive();

  const router = useRouter();
  const pathname = router.pathname;
  const isAdminPage = pathname.includes("/admin");
  const hiddenRoutes = [
    "/admin/signin",
    "/100",
    "/admin/disposal-complete",
    "/admin/company/[id]/funeral-service-for-user",
    "/admin/goi/all-send-history",
    "/admin/goi/disposal-stock-list",
    "/admin/goi/disposal-stock-list/new-order",
    "/admin/goi/team-register",
    "/admin/goi/user-register",
    "/admin/goi/sangjo-service-page-list",
    "/admin/goi/leads",
    "/calculator/1",
    "/calculator/3",
  ];
  const isHiddenHeaderRoute = !hiddenRoutes.includes(pathname);

  return (
    <>
      {!isAdminPage && isHiddenHeaderRoute && (
        <>
          <Header />
          <Spacing gap={isBiggerThanLg ? 66 : 96} />
        </>
      )}

      {isAdminPage && isHiddenHeaderRoute && (
        <>
          <B2BOpsHeader />
        </>
      )}
      <VStack>{children}</VStack>
    </>
  );
}
